// types.ts for authentication feature

//~ Define your core data model interfaces for this feature
export interface UserData {
    id: string;
    username: string;
    email: string;
}

export const DEFAULT_USER_DATA: UserData = {
    id: '',
    username: '',
    email: '',
};

//~ Define Backend response types if they differ significantly from your frontend model
export interface AuthenticationsResponse {
    loginTime: number | undefined;
    sessionExpiryTime: number | undefined;
    token: string | undefined;
}

export interface BackendAuthenticationResponse {
    needsSecondToken: boolean;
    status: number;
    token: string;
}

export interface GetUserDataResponse {
    activated: number;
    created: number;
    createdBy: string;
    email: string;
    emailHash: string;
    fullName: string;
    hasAvatar: boolean;
    href: string;
    hrefs: {
        accountrights: string;
        accounts: string;
        debug: string;
        debugs: string;
        intercomhash: string;
        invitations: string;
        productions: string;
        roles: string;
        settings: string;
        systemProperties: string;
        systemrights: string;
    };
    id: string;
    lastIndexCompleted: number;
    lastIndexed: number;
    lastSeen: number;
    lastUpdated: number;
    objectType: string;
    type: string;
    username: string;
    version: number;
}

//~ Define specific query arguments if not in the API file direclty
export interface LoginQueryArgs {
    username: string;
    password: string;
    rememberMe?: boolean;
}

export type GetUserDataArgs = void;

//~ Define the state shape for your authentication feature's local UI state
export interface AuthenticationState {
    loginTime: number | undefined;
    sessionExpiryTime: number | undefined;
    token: string | undefined;
    user: UserData | undefined;
}
